export default function BrandWordmark({
  className = 'h-12 w-12',
}) {
  return (
    <span className={`inline-flex items-center justify-center overflow-hidden ${className}`.trim()}>
      <img
        src="/new-logo.svg"
        alt="Accurix"
        className="w-full h-full object-contain"
      />
    </span>
  )
}